export const australianUniversities = [
  // New South Wales
  { name: 'University of Sydney', location: 'Sydney, NSW', state: 'NSW' },
  { name: 'University of New South Wales (UNSW)', location: 'Sydney, NSW', state: 'NSW' },
  { name: 'University of Technology Sydney (UTS)', location: 'Sydney, NSW', state: 'NSW' },
  { name: 'Macquarie University', location: 'Sydney, NSW', state: 'NSW' },
  { name: 'University of Newcastle', location: 'Newcastle, NSW', state: 'NSW' },
  { name: 'University of Wollongong', location: 'Wollongong, NSW', state: 'NSW' },
  { name: 'Western Sydney University', location: 'Sydney, NSW', state: 'NSW' },
  { name: 'Australian Catholic University', location: 'Multiple Locations, NSW', state: 'NSW' },
  
  // Victoria
  { name: 'University of Melbourne', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'Monash University', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'RMIT University', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'Deakin University', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'La Trobe University', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'Swinburne University of Technology', location: 'Melbourne, VIC', state: 'VIC' },
  { name: 'Victoria University', location: 'Melbourne, VIC', state: 'VIC' },
  
  // Queensland
  { name: 'University of Queensland', location: 'Brisbane, QLD', state: 'QLD' },
  { name: 'Queensland University of Technology (QUT)', location: 'Brisbane, QLD', state: 'QLD' },
  { name: 'Griffith University', location: 'Brisbane, QLD', state: 'QLD' },
  { name: 'James Cook University', location: 'Townsville, QLD', state: 'QLD' },
  { name: 'University of the Sunshine Coast', location: 'Sunshine Coast, QLD', state: 'QLD' },
  { name: 'Central Queensland University', location: 'Rockhampton, QLD', state: 'QLD' },
  { name: 'Bond University', location: 'Gold Coast, QLD', state: 'QLD' },
  
  // Western Australia
  { name: 'University of Western Australia', location: 'Perth, WA', state: 'WA' },
  { name: 'Curtin University', location: 'Perth, WA', state: 'WA' },
  { name: 'Murdoch University', location: 'Perth, WA', state: 'WA' },
  { name: 'Edith Cowan University', location: 'Perth, WA', state: 'WA' },
  
  // South Australia
  { name: 'University of Adelaide', location: 'Adelaide, SA', state: 'SA' },
  { name: 'University of South Australia', location: 'Adelaide, SA', state: 'SA' },
  { name: 'Flinders University', location: 'Adelaide, SA', state: 'SA' },
  
  // Australian Capital Territory
  { name: 'Australian National University', location: 'Canberra, ACT', state: 'ACT' },
  { name: 'University of Canberra', location: 'Canberra, ACT', state: 'ACT' },
  
  // Tasmania
  { name: 'University of Tasmania', location: 'Hobart, TAS', state: 'TAS' },
  
  // Northern Territory
  { name: 'Charles Darwin University', location: 'Darwin, NT', state: 'NT' }
];